import { FormNewPassword } from './FormContainer';

export const UserProfile = ({ profileUser }) => {
    return <FormNewPassword infoProfile={profileUser} />;
};
